"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ensureValidLinks = exports.ensureValidUrl = exports.isValid = exports.sanitize = void 0;

var _dompurify = _interopRequireDefault(require("dompurify"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Same as Flux
// Removing 'b' tag from whitelist as it conflicts with RTE behaviour
var SANITIZATION_CONFIG = {
  ALLOWED_TAGS: ['img', 'p', 'html', 'body', 'strong', 'th', 'td', 'tr', 's', 'li', 'em', 'i', 'sub', 'div', 'head', 'font', 'g', 'u', 'sup', 'ol', 'code', 'a', 'h1', 'h2', 'h3', 'h4', 'tbody', 'pre', 'br', 'blockquote', 'wbr', 'ul', 'span', 'table', 'hr', 'ins', 'center', 'dynamic-field'],
  ALLOWED_ATTR: ['src', 'class', 'alt', 'width', 'height', 'rel', 'type', 'href', 'rel', 'target', 'data-fr-link', 'title', 'style', 'dir', 'align', 'bgcolor', 'valign', 'cellpadding', 'cellspacing', 'colspan', 'width', 'height', 'border', 'open', 'crossorigin', 'size'],
  ALLOW_ARIA_ATTR: false
}; // All use of DOMPurify should go through this, a) to support both client and
// server environments, and b) to provide a sensible error if things go wrong

var getDomPurify = dom => {
  if (typeof window === 'undefined' && !dom) {
    throw new Error('Unable to initialize DOMPurify. No window or DOM instance was found.');
  }

  return dom ? (0, _dompurify.default)(dom) : _dompurify.default;
};

var sanitize = function sanitize(html) {
  var dom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return getDomPurify(dom).sanitize(html, SANITIZATION_CONFIG);
};

exports.sanitize = sanitize;

var isValid = function isValid(html) {
  var _purify$removed;

  var dom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!html) {
    return true;
  }

  var purify = getDomPurify(dom);
  sanitize(html);

  if ((_purify$removed = purify.removed) === null || _purify$removed === void 0 ? void 0 : _purify$removed.length) {
    return false;
  }

  return true;
};

exports.isValid = isValid;

var ensureValidUrl = url => {
  // It has a scheme; we don't need to do anything
  if (url.match(/^(https|http|tel|mailto):/)) {
    return url;
  } // It has a domain, so we can safely add a scheme


  if (url.match(/^[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+/)) {
    return "https://".concat(url);
  } // It's a relative path


  return url;
};

exports.ensureValidUrl = ensureValidUrl;

var ensureValidLinks = content => content.replace(/href="([^"]+)"/g, (match, href) => "href=\"".concat(ensureValidUrl(href), "\""));

exports.ensureValidLinks = ensureValidLinks;